import styled from 'styled-components'

import { TransparentIconButton } from '../../Button'

export const DatepickerNextNavButton = styled((props) => {
  return (
    <TransparentIconButton
      icon='chevron-thick-right'
      {...props}
      aria-label='Next'
    />
  )
})`
  position: absolute;
  top: ${(props) => props.theme.typography.pxToRem(18)};
  right: ${(props) => props.theme.typography.pxToRem(22)};
`
